import React from 'react'
import { NavLink } from 'react-router-dom'
import './style.scss'

const MyBiyesadi = () => {
    return (
        <div className="custom-navbar">
            <div className="container">
                <div className="row">
                    <div className="col-12 text-center">
                        <NavLink
                            exact
                            type="button"
                            className="btn shadow-sm"
                            to="/my-metrimony/"
                            activeClassName="isActive"
                        >Dashboard</NavLink>
                        <NavLink
                            exact
                            type="button"
                            className="btn shadow-sm"
                            to="/my-metrimony/profile"
                            activeClassName="isActive"
                        >profile</NavLink>
                        <NavLink
                            exact
                            type="button"
                            className="btn shadow-sm"
                            to="/my-metrimony/photos"
                            activeClassName="isActive"
                        >photo</NavLink>
                        <NavLink
                            exact
                            type="button"
                            className="btn shadow-sm"
                            to="/my-metrimony/partner-preference"
                            activeClassName="isActive"
                        >partner preference</NavLink>
                        <NavLink
                            exact
                            type="button"
                            className="btn shadow-sm"
                            to="/my-metrimony/settings"
                            activeClassName="isActive"
                        >settings</NavLink>
                        <NavLink
                            exact
                            type="button"
                            className="btn shadow-sm"
                            to="/my-metrimony/contact"
                            activeClassName="isActive"
                        >contact details</NavLink>
                        <NavLink
                            exact
                            type="button"
                            className="btn shadow-sm"
                            to="/my-metrimony/package"
                            activeClassName="isActive"
                        >packages</NavLink>
                        <NavLink
                            exact
                            type="button"
                            className="btn shadow-sm"
                            to="/my-metrimony/paymentlog"
                            activeClassName="isActive"
                        >payment log</NavLink>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default MyBiyesadi;